// Mutation hook - przypisanie watku Notify do istniejacego dealu.
// POST /api/ui/sales-crm/notify/threads/{threadId}/assign-to-deal
// Sprint 4 v4.1.

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type {
  IPostAssignThreadToDealRequest,
  IPostAssignThreadToDealResponse
} from 'api/types/notify';
import { NOTIFY_INBOX_QUERY_KEY_BASE } from 'api/endpoints/useGetNotifyInbox';

export interface IUsePostAssignThreadToDealVariables {
  threadId: number;
  body: IPostAssignThreadToDealRequest;
}

const postAssignThreadToDeal = ({
  threadId,
  body
}: IUsePostAssignThreadToDealVariables): Promise<IPostAssignThreadToDealResponse> =>
  axios.post(`/sales-crm/notify/threads/${threadId}/assign-to-deal`, body);

export const usePostAssignThreadToDeal = (
  options?: UseMutationOptions<
    IPostAssignThreadToDealResponse,
    IError,
    IUsePostAssignThreadToDealVariables
  >
) => {
  const queryClient = useQueryClient();
  return useMutation<
    IPostAssignThreadToDealResponse,
    IError,
    IUsePostAssignThreadToDealVariables
  >(postAssignThreadToDeal, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(NOTIFY_INBOX_QUERY_KEY_BASE);
      await queryClient.invalidateQueries(['sales-crm-notify', 'by-deal']);
      await queryClient.invalidateQueries(['sales-crm-notify', 'by-thread', variables.threadId]);
      await queryClient.invalidateQueries(['sales-crm-notify', 'threads', 'by-deal']);
      options?.onSuccess?.(data, variables, context);
    }
  });
};
